<!-- P3: the old copy ("… a category to assign FlyCut to?") wrapped to four
     lines in the narrow panel and orphaned "to?" on the last one. -->
<div vng-dialog-title class="text-center">Please <strong>pick</strong> or <strong>create</strong> a category</div>
<div style="display: flex" class="top-gap">
  <!-- Shared app-category-select (same recipe as add-shortcut). Per-option
       (click)="setCategoryLevel(N)" stays a data-driven `data.level` read back
       in (selectionChange); creation stays here via shortcutCategoryRename. -->
  <app-category-select
    #categorySelect
    style="flex: 1"
    label="Pick a category"
    [control]="category"
    [options]="categoryOptions"
    (selectionChange)="onCategorySelected($event)"
    (createCategory)="shortcutCategoryRename($event ? { name: $event } : {})"
  ></app-category-select>
</div>
<div class="dialog-actions">
  <button style="flex: 1" class="btn-cta btn-secondary" type="button" vng-button variant="outline" tabindex="2" (click)="onNoClick()">
    Cancel
  </button>
  <button
    style="flex: 1"
    (click)="onSaveCLick()"
    class="btn-cta btn-primary"
    type="button"
    vng-button
    variant="primary"
    tabindex="-1"
  >
    Update
  </button>
</div>
